import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminAIReportFeedbacksPage, type AdminAIReportFeedbacksPageProps } from '../ui/admin/AdminAIReportFeedbacksPage';

export function AdminAIReportFeedbacksPageContainer(props: AdminAIReportFeedbacksPageProps) {
  return <AdminAIReportFeedbacksPage {...props} />;
}

export function mountAdminAIReportFeedbacksPage(
  container: HTMLElement,
  props: AdminAIReportFeedbacksPageProps
) {
  const root = createRoot(container);
  root.render(<AdminAIReportFeedbacksPageContainer {...props} />);
  return root;
}

export default AdminAIReportFeedbacksPageContainer;
